import { render } from "./aboutStory.vue?vue&type=template&id=4941fc1f&scoped=true"
import script from "./aboutStory.vue?vue&type=script&lang=js"
export * from "./aboutStory.vue?vue&type=script&lang=js"

import "./aboutStory.vue?vue&type=style&index=0&id=4941fc1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4941fc1f"]])

export default __exports__